export const Institutes=[
    "Technion - Israel Institute of Technology",
    "Hebrew University of Jerusalem",
    "Weizmann Institute of Science",
    "Bar-Ilan University",
    "Tel Aviv University",
    "University of Haifa",
    "Ben-Gurion University of the Negev",
    "Open University of Israel",
    "Ariel University",
    "Reichman University",
    "Academic College of Tel Aviv-Yafo",
    "Afeka College of Engineering",
    "Ashkelon Academic College",
    "Carmel Academic Center",
    "Center for Academic Studies",
    "College of Management Academic Studies (COMAS)",
    "Dan Academic Center",
    "Hadassah Academic College",
    "Holon Institute of Technology",
    "Jerusalem College of Engineering",
    "Kinneret Academic College",
    "Lander Institute",
    "Lev Academic Center",
    "Max Stern Academic College of Emek Yezreel",
    "Mivhar College",
    "Netanya Academic College",
    "Ono Academic College, Kiryat Ono",
    "ORT Braude College of Engineering",
    "Peres Academic Center",
    "Ruppin Academic Center",
    "Sapir Academic College",
    "Sami Shamoon College of Engineering",
    "Sha'arei Mishpat College",
    "Shalem College",
    "Shenkar College of Engineering and Design",
    "Tel-Hai Academic College",
    "Western Galilee College",
    "Yehuda Regional College",
    "Zefat Academic College",
];

export const IDEs=[
    "Visual Studio",
    "Visual Studio Code",
    "Eclipse",
    "Android Studio",
    "Xcode",
    "Sublime",
    "PyCharm",
    "WebStorm",
    "NetBeans",
    "IntelliJ",
    "Atom",
    "PhpStorm",
    "Emacs",
    "Xamarin",
    "Komodo",
    "RStudio"
]